export default "__VITE_ASSET__VrqpVPFb__"